
import Coming from "../components/Coming";
export default function ITConsulting() {
    return(
            <>
                <input type="hidden" id="comingDate" value="2024/4/21"/>
                <Coming />
            </>
    );
}